import React from 'react';
import { Col, Container, Row } from '@gjensidige/core-grid';
import { Title } from '@gjensidige/core-typography';
import { useCmsContext } from '@gjensidige/service-cms';

import { CriticalButton } from '../Button';
import styles from './AskAdvisor.module.scss';

const AskAdvisor = () => {
  const { getText } = useCmsContext();
  return (
    <Container>
      <Row>
        <Col xs={12} md={{ offset: 3, span: 6 }}>
          <div className={styles.box}>
            <Title tag="h2" size="h3">
              {getText('housing.check.summary.askAdvisor.title')}
            </Title>
            <CriticalButton color="green">
              <a
                href="https://www.gjensidige.no/privat/radgivning"
                rel="noreferrer"
                target="_blank"
                className={styles.link}
              >
                {getText('housing.check.summary.askAdvisor.button')}
              </a>
            </CriticalButton>
          </div>
        </Col>
      </Row>
    </Container>
  );
};

export default AskAdvisor;
